module.exports = __webpack_public_path__ + "static/media/camper_van_binnen.0bd501db.jpeg";